import {create, type TSetter} from "@/store/createStore";
import type {TInterest, TNonFunctionKeys} from "@/store/types";
import {devtools} from "zustand/middleware";
import {immer} from "zustand/middleware/immer";

type TState = {
  categories: TInterest[];
  adminCategories: TInterest[];
  maxAllowedCategories: number;
  setter: TSetter<TState>;
};

const initialState = {
  categories: [],
  adminCategories: [],
  maxAllowedCategories: 4,
} satisfies Pick<TState, TNonFunctionKeys<TState>>;

const useCategoryStore = create<TState>()(
  immer(
    devtools(
      set => ({
        ...initialState,
        setter: fn => set(fn, false, "useCategoryStore/setter"),
      }),
      {name: "useCategoryStore"},
    ),
  ),
);

export {useCategoryStore};
